/* jshint esversion: 6 */
/* jshint esversion: 11 */
import { useContext, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
const PayFast = ({ Amount, attributes }) => {

    const { setPaymentLod } = useContext(MyContext);

    const handleCheckout = () => {
        sessionStorage.setItem("Amount", Amount);
        
        setPaymentLod(false);

        const paymentData = {
            merchant_id: attributes?.split(",")[1],
            merchant_key: attributes?.split(",")[0],
            amount: Amount,
            item_name: 'Test Item',
            return_url: window.location.origin + "/done",
            cancel_url: window.location.origin + '/cancel',
            notify_url: 'https://yournotificationurl.com',
        };

        const form = document.createElement('form');
        form.action = 'https://sandbox.payfast.co.za/eng/process';
        form.method = 'POST';

        Object.keys(paymentData).forEach(key => {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = paymentData[key];
            form.appendChild(hiddenField);
        });

        document.body.appendChild(form);
        form.submit();
    };


    useEffect(() => {
        if (Amount) {
            handleCheckout();
        }
    }, []);

    return null;
};

export default PayFast;